import { Observable } from 'rxjs';
import { BaseResponse } from '../../data/shared/base.response';
import { Tenant } from '../domain/models/tenant';
import { FeatureConfiguration } from '../domain/models/feature-configuration';

export abstract class TenantRepository {
  abstract getTenantById(request: string): Observable<Tenant>;
  abstract getFeatureConfigurations(): Observable<FeatureConfiguration[]>;
}
